var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGoogle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 20,
    viewBox: "0 0 19 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_10837_235)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.37391 11.9207L3.733 14.3133L1.39048 14.3628C0.69041 13.0643 0.29332 11.5787 0.29332 10C0.29332 8.47339 0.66459 7.03376 1.32269 5.76614H1.32319L3.40869 6.14849L4.32227 8.22147C4.13106 8.77892 4.02684 9.37732 4.02684 10C4.02691 10.6758 4.14933 11.3233 4.37391 11.9207Z",
    fill: "#FBBB00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.5451 8.28016C18.6508 8.83706 18.7059 9.4122 18.7059 10C18.7059 10.6591 18.6366 11.302 18.5046 11.9222C18.0564 14.0325 16.8854 15.8753 15.2632 17.1793L15.2627 17.1788L12.6359 17.0448L12.2641 14.724C13.3405 14.0927 14.1818 13.1048 14.6249 11.9222H9.70207V8.28016H14.6967H18.5451Z",
    fill: "#518EF8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.2625 17.1788L15.263 17.1793C13.6853 18.4475 11.6812 19.2062 9.49953 19.2062C5.99357 19.2062 2.94541 17.2466 1.39046 14.3628L4.37389 11.9207C5.15135 13.9956 7.15295 15.4727 9.49953 15.4727C10.5082 15.4727 11.4531 15.2 12.2639 14.724L15.2625 17.1788Z",
    fill: "#28B446"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.3761 2.91324L12.3937 5.3549C11.5545 4.83037 10.5626 4.52735 9.49981 4.52735C7.10012 4.52735 5.06108 6.07216 4.32257 8.2215L1.32346 5.76616H1.32295C2.85514 2.81208 5.94175 0.793793 9.49981 0.793793C11.7336 0.793793 13.7817 1.58948 15.3761 2.91324Z",
    fill: "#F14336"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_10837_235"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18.4125,
    height: 18.4125,
    fill: "white",
    transform: "translate(0.293762 0.79377)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogle);
export default __webpack_public_path__ + "static/media/google.b2a9d010641c339a6b9060624f1e4648.svg";
export { ForwardRef as ReactComponent };